import { SearchObject } from "app/common/Model/SearchObject";
import { PageResponse } from "app/common/Model/Shared";
import {
  getVoucherItemSalesAllocation,
  pageOverViewReport,
} from "app/services/ReportService";
import { exportExcelDistributionGeneralReport } from "app/services/StaffRevenueService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportOverviewStore {
  pageDataOverview = new PageResponse();
  searchReportOverview = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    listDepId: [],
    staffId: [],
    voucherItemRevenueType: null,
    listStaffGroupId: [],
  };
  detailVoucherItems = []; // lưu chi tiết voucher
  loadingDetail = false;
  popupOpen = false;
  constructor() {
    makeAutoObservable(this);
  }
  handleChangeFormSearchOverview = async (searchReportOverview) => {
    this.searchReportOverview = {
      ...this.searchReportOverview,
      ...searchReportOverview,
    };
    await this.pagingReportOverview();
  };

  getVoucherItemSalesDetail = async (staffId) => {
    this.loadingDetail = true;
    this.popupOpen = true;
    try {
      const search = this.normalizeSearchReportOverview({
        ...this.searchReportOverview,
        staffId: [staffId],
      });

      const { data } = await getVoucherItemSalesAllocation(search);
      this.detailVoucherItems = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu chi tiết lỗi");
    } finally {
      this.loadingDetail = false;
    }
  };

  closePopupDetail = () => {
    this.popupOpen = false;
    this.detailVoucherItems = [];
  };

  pagingReportOverview = async () => {
    // Không call API nếu không có cơ sở (bắt buộc)
    if (!this.searchReportOverview.listDepId || this.searchReportOverview.listDepId.length === 0) {
      this.pageDataOverview = new PageResponse();
      return;
    }
    
    const search = this.normalizeSearchReportOverview(
      this.searchReportOverview
    );
    try {
      const { data } = await pageOverViewReport({ ...search });

      this.pageDataOverview = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu cáo cáo doanh thu chi tiết (nguồn) có lỗi");
    }
  };

  normalizeSearchReportOverview = (rawSearch = {}) => {
    const { listDepId, staffId, listStaffGroupId, ...rest } = rawSearch;
    return {
      ...rest,
      listDepId: Array.isArray(listDepId) ? listDepId.map((x) => x.id) : [],
      listStaffGroupId: Array.isArray(listStaffGroupId) ? listStaffGroupId.map((x) => x.id) : [],
      staffIds: staffId
        ? Array.isArray(staffId)
          ? staffId.map((x) => (x?.id ? x.id : x)) // nếu là object hoặc string
          : [staffId] // nếu là string
        : [],
    };
  };

  handleExportOverview = async (searchObj) => {
    if (!(searchObj?.listDepId?.length > 0)) {
      toast.error("Vui lòng chọn cơ sở để xuất excel");
      return;
    }
    try {
      const response = await exportExcelDistributionGeneralReport(
        this.normalizeSearchReportOverview({
          ...this.searchReportOverview,
          ...searchObj,
        })
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "BAO_CAO_DOANH_THU_CHI_TIET_THEO_NGUON_TONG_QUAT.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Export failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  resetStore = () => {
    this.listData = null;
    this.searchFee = {
      ...new SearchObject(),

      listDepId: [],
      // orgIds: [],
    };
  };
}
